import state from './usersystemfavorite.state'
import mutations from './usersystemfavorite.mutations'
import actions from './usersystemfavorite.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
